import { connect } from 'react-redux'
import HyperLinkToolBarComponent from "../components/HyperLinkToolBarComponent";
import {addLinkToText,addLinkToObj,setSelectedScene} from "../actions/index"

const mapStateToProps = (state, ownProps) => ({
    selectedScene   : state.localStore.get("selectedScene"),
    selectedItems   : state.localStore.get("selectedItems"),
    workspaceWidth  : state.project.get("width"),
    workspaceHeight  : state.project.get("height"),
    selectedObjects : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceItems"]).filter(function(obj, key){return state.localStore.get("selectedItems").keyOf(key) !== undefined;}),
    zoomFactor : state.localStore.get('zoomFactor'),
    workspaceBounds : state.localStore.get('workspaceBounds'),
    selectionBox : state.localStore.get("selectionBox"),
    workspaceChildren : state.project.getIn(["scenes", state.localStore.get("selectedScene"), "workspaceChildren"]),
    propertyWindow  : state.localStore.get("propertyWindow"),
    textStatus      : state.localStore.get("textStatus"),
    isWorkspaceTextFocus: state.localStore.get('isWorkspaceTextFocus'),
    transformStatus : state.localStore.get('transformStatus'),
    workspaceStage      : state.localStore.get("workspaceStage"),
    showSlidePanel      : state.localStore.get("showSlidePanel"),
    animakerType : state.localStore.get('animakerType'),
    undoProp    :   state.localStore.get('undoProp'),
    updateItems : state.localStore.get('itemToUpdate'),
    textOffset : state.localStore.get('textOffset'),
    scenes     : state.project.getIn(["scenes"]),

  
})
const mapDispatchToProps = (dispatch, ownProps) => ({

    addLinkToText : (data , socket) => {dispatch(addLinkToText(data, socket))},
    addLinkToObj : (data , socket) => {dispatch(addLinkToObj(data, socket))},
    setSelectedScene    : (data, time, selectedScenes, socket) =>
    {
        dispatch(setSelectedScene(data, time, selectedScenes, socket))
    },


  
   
})
       

const HyperLinkToolBar = connect(mapStateToProps,mapDispatchToProps)(HyperLinkToolBarComponent)

export default HyperLinkToolBar



// WEBPACK FOOTER //
// ./src/containers/HyperLinkToolBar.js